import Reports from '@/services/Api/Awards/Reports';
import { handleAuthorization, handleFormValidations } from '@ifac/ui';

export default {
  methods: {
    mx_fetchAwardReports(award) {
      return Reports.all({
        type: 'award',
        award_id: award.id,
      });
    },
    mx_fetchNominationReports(nomination) {
        return Reports.all({
          type: 'nomination',
          nomination_id: nomination.id,
        });
    },
    mx_update(report) {
      this.formErrors = {};
      Reports
        .update(report.id, {
          form_values: this.formValues,
        })
        .then(() => {
          this.$snack.success({ text: 'Report saved' });
        })
        .catch((error) => {
          handleAuthorization(error).then((msg) => {
            if (msg) {
              this.$snack.success({ text: msg });
            }
          });

          handleFormValidations(error).then((errors) => {
            if (errors) {
              this.$snack.success({
                text: 'You have some validation errors, try again please.',
              });
              this.formErrors = errors;
            }
          });
        });
    },
    mx_submit(report) {
      this.formErrors = {};
      return Reports.submit(report.id, {
        form_values: this.formValues,
      })
        .then(() => {
          this.$snack.success({ text: 'Report submitted' });
          this.$emit('reportSubmitted');
        })
        .catch((error) => {
        handleAuthorization(error).then((msg) => {
          this.$snack.success({ text: msg });
        });

        handleFormValidations(error).then((errors) => {
          this.$snack.success({
            text: 'You have some validation errors, try again please.',
          });
          this.formErrors = errors;
        });
      });
    },
  },
};
